<template>
  <nav class="layout-footer footer" :class="getLayoutFooterBg()">
    <div class="container-fluid d-flex flex-wrap justify-content-between text-center container-p-x pb-3">
      <div class="pt-3">
        <span>
          <img src="/img/footer-logo.png">
        </span>
        &nbsp;
        <span class="footer-text font-weight-bold" style="color: rgb(0, 76, 153); align-items: center">
          Zion ©</span> AMITS
      </div>
      <div class="pt-3">
        <span class="footer-text font-weight-light">User logged in: <strong>{{loginid}}</strong></span>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'app-layout-footer',
  data () {
    return {
      loginid: localStorage.getItem('uname')
    }
  },
  methods: {
    getLayoutFooterBg () {
      return `bg-${this.layoutFooterBg}`
    }
  }
}
</script>
